import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon, Modal } from '@pella/sash-framework';
import { classNames } from '@pella/sash-framework/dist/utilities';
import { Image } from '../../../';

import StaticMap from '../../../common/static-map';
import SliderWithThumbnails from '../../../common/slider-with-thumbnails';

const MapCollage = ({ mapLocation, type, images }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const imageSlice = type === 'map portrait 2' ? 2 : 1;

	const onModalTriggerClick = () => setIsModalOpen(!isModalOpen);

	const classes = classNames({
		'mapCollage grid h-60 md:h-80 xl:h-[345px]': true,
		'grid-cols-1 grid-row-1': type === 'map only',
		'grid-cols-2 grid-rows-1': type === 'map portrait',
		'grid-cols-1 grid-rows-2': type === 'map landscape',
		'grid-cols-2 grid-rows-2 md:grid-rows-1': type === 'map portrait 2',
	});

	const mapClasses = classNames({
		'!h-full': true,
		'col-start-1': type === 'map portrait',
		'row-start-2 md:row-start-1': type === 'map landscape',
		'col-start-1 col-span-2 md:col-span-1 row-start-2 md:row-start-1': type === 'map portrait 2',
	});

	const imageClasses = classNames({
		'flex relative h-full w-full': true,
		'col-start-2': type === 'map portrait',
		'row-start-1 md:row-start-2 [&>*]:flex-12/12': type === 'map landscape',
		'col-start-1 col-span-2 md:col-start-2 md:col-span-1 row-start-1 row-span-1 md:[&>*]:h-1/2 md:flex-col': type === 'map portrait 2',
	});

	return (
		<div className={classes}>
			<StaticMap
				title='Google map location'
				mapLocation={mapLocation}
				className={mapClasses}
			/>

			{type !== 'map only' && images?.[0] && (
				<div className={imageClasses}>
					{images.slice(0, imageSlice).map((image, index) => (
						<button
							onClick={onModalTriggerClick}
							aria-label='View image in modal'
							className='h-full w-full'
							key={index}
						>
							<Image
								data={image}
								className='!block h-full w-full !object-cover'
							/>
						</button>
					))}

					<button
						onClick={onModalTriggerClick}
						aria-label='View More Images'
						className='absolute bottom-1.5 right-1.5 flex !h-auto items-center bg-black px-2 py-1 text-xs text-white'
					>
						<Icon
							name='photo_library'
							size={14}
							className='mr-1'
						/>
						<span>{images.length} Photos</span>
					</button>
				</div>
			)}

			<Modal
				isOpen={isModalOpen}
				onClose={onModalTriggerClick}
				width={800}
			>
				<Modal.Content className='pt-16'>
					<SliderWithThumbnails
						images={images}
						className='[&_img]:max-h-[300px] xl:[&_img]:max-h-[460px]'
					/>
				</Modal.Content>
			</Modal>
		</div>
	);
};

MapCollage.propTypes = {
	mapLocation: PropTypes.string,
	type: PropTypes.string,
	images: PropTypes.array,
};

export default MapCollage;
